/* eslint-disable react/prop-types */
import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faFileUpload } from '@fortawesome/free-solid-svg-icons';

const PatientFilesToolbar = ({ canUpload, missingContext, onOpenUpload }) => {
    if (!canUpload) return null;

    return (
        <div className="patient-files__toolbar">
            <button
                type="button"
                className="patient-files__upload-trigger"
                onClick={onOpenUpload}
                disabled={missingContext}
                title={
                    missingContext
                        ? 'Organization, location, patient, or visit is missing'
                        : 'Upload a file or document'
                }
            >
                <FontAwesomeIcon icon={faFileUpload} className="me-1" size="xs" />
                Upload file / Document
            </button>
            {missingContext && (
                <span className="patient-files__hint text-danger">
                    Select organization &amp; location in your role and open a visit to upload.
                </span>
            )}
        </div>
    );
};

export default PatientFilesToolbar;
